// ========================================================================================================== SECTION 1
gsap.set('.co-about-section-1', { opacity: 0 });
gsap.set('.co-about-section-1-right-frame-1', { scale: 1.2 });
gsap.set('.co-about-section-1-ani-item', { y: 20, opacity: 0 });

let coAboutHeroTimeline = gsap.timeline();

coAboutHeroTimeline.to('.co-about-section-1', {
  opacity: 1,
  ease: "power2.inOut",
  duration: 1
});
coAboutHeroTimeline.to('.co-about-section-1-right-frame-1', {
  scale: 1,
  ease: "power2.inOut",
  duration: 0.75
}, "-=0.75");
coAboutHeroTimeline.to('.co-about-section-1-ani-item', {
  y: 0,
  opacity: 1,
  ease: "power2.inOut",
  duration: 0.75,
  stagger: 0.1
}, "-=0.75");

gsap.set('.co-about-section-1-left-image-bg-frame-2 img', { top: "-10%", height: "110%" });
gsap.to('.co-about-section-1-left-image-bg-frame-2 img', {
  scrollTrigger: {
    // markers: true,
    trigger: 'body',
    endTrigger: '.co-about-section-1',
    start: "top top",
    end: "bottom top",
    scrub: 1
  },
  top: "0%"
})

gsap.set('.co-about-section-1-right-image-bg img', { top: "0%", height: "110%" });
gsap.to('.co-about-section-1-right-image-bg img', {
  scrollTrigger: {
    // markers: true,
    trigger: 'body',
    endTrigger: '.co-about-section-1',
    start: "top top",
    end: "bottom top",
    scrub: 1
  },
  top: "-10%"
})

gsap.set('.co-about-section-1-right-image img', { scale: 1 });
gsap.to('.co-about-section-1-right-image img', {
  scrollTrigger: {
    // markers: true,
    trigger: 'body',
    endTrigger: '.co-about-section-1',
    start: "top top",
    end: "bottom top",
    scrub: 1
  },
  scale: 1.1
})

// ========================================================================================================== SECTION 2

gsap.set('.co-about-section-2-ani-item', { opacity: 0, y: 20 });
gsap.to('.co-about-section-2-ani-item', {
  scrollTrigger: {
    // markers: true,
    trigger: '.co-about-section-2',
    start: "25% bottom",
    end: "bottom top",
  },
  y: 0,
  opacity: 1,
  ease: "power2.inOut",
  duration: 1,
  stagger: 0.1
})
// ========================================================================================================== SECTION 3
if (!document.documentElement.classList.contains('shopify-design-mode')) {
  // ===================================================== PIN
  document.querySelectorAll('.co-about-section-3-slides-wrapper').forEach((slide, i) => {
    ScrollTrigger.create({
      // markers: true,
      trigger: slide,
      start: "top top",
      pinSpacing: false,  // Adjust to `true` if you need spacing after pinning
      end: () => `+=${slide.offsetHeight}`, // Pin for the height of the slide
      pin: true
    });
  });
  // ===================================================== ENTRY
  let coAboutFadeEase = "power4.inOut";
  let coAboutFadeDuration = 0.75;
  let coAboutStaggerDuration = 0;
  let coAboutDelayDuration = 0;
  
  let coAboutSlide1EntryStart = "0% 50%";
  let coAboutSlide1EntryEnd = "25% 50%";
  let coAboutSlide1ScrubStart = "0% top";
  let coAboutSlide1ScrubEnd = "25% 50%";
  
  let coAboutSlide2Start = "25% 50%";
  let coAboutSlide2End = "47.5% 50%";
  
  let coAboutSlide3Start = "47.5% 50%";
  let coAboutSlide3End = "70% 50%";
  
  let coAboutSlide4Start = "70% 50%";
  let coAboutSlide4End = "100% 50%";
  
  // SLIDE 1
  gsap.set('.co-about-section-3-slide-1', { autoAlpha: 1 });
  gsap.to('.co-about-section-3-slide-1', {
    scrollTrigger: {
      // markers: true,
      toggleActions: "none play reverse none",
      trigger: '.co-about-section-3-slides-main-wrapper',
      start: coAboutSlide1EntryStart,
      end: coAboutSlide1EntryEnd,
    },
    duration: coAboutFadeDuration,
    ease: coAboutFadeEase,
    autoAlpha: 0
  })
  // slide 1 bg image
  gsap.set('.co-about-section-3-slide-1 .co-about-section-3-slide-image-2', { top: "0%" });
  gsap.to('.co-about-section-3-slide-1 .co-about-section-3-slide-image-2', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-about-section-3-slides-main-wrapper',
      start: coAboutSlide1ScrubStart,
      end: coAboutSlide1ScrubEnd,
      scrub: 0.5
    },
    top: "-5%"
  })
  // slide 1 center image
  gsap.set('.co-about-section-3-slide-1 .co-about-section-3-slide-image-1-frame-2 img', { top: "-5%" });
  gsap.to('.co-about-section-3-slide-1 .co-about-section-3-slide-image-1-frame-2 img', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-about-section-3-slides-main-wrapper',
      start: coAboutSlide1ScrubStart,
      end: coAboutSlide1ScrubEnd,
      scrub: 0.6
    },
    top: "0%"
  })
  // SLIDE 2
  gsap.set('.co-about-section-3-slide-2', { autoAlpha: 0 });
  gsap.to('.co-about-section-3-slide-2', {
    scrollTrigger: {
      // markers: true,
      toggleActions: "play reverse play reverse",
      trigger: '.co-about-section-3-slides-main-wrapper',
      start: coAboutSlide2Start,
      end: coAboutSlide2End,
    },
    duration: coAboutFadeDuration,
    ease: coAboutFadeEase,
    autoAlpha: 1
  })
  // slide 2 center image frame
  gsap.set('.co-about-section-3-slide-2 .co-about-section-3-slide-image-1-frame-2', { scale: 1 });
  gsap.to('.co-about-section-3-slide-2 .co-about-section-3-slide-image-1-frame-2', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-about-section-3-slides-main-wrapper',
      start: coAboutSlide2Start,
      end: coAboutSlide2End,
      scrub: 0.5
    },
    scale: 1.1
  })
  // slide 2 center image
  gsap.set('.co-about-section-3-slide-2 .co-about-section-3-slide-image-1-frame-2 img', { scale: 1 });
  gsap.to('.co-about-section-3-slide-2 .co-about-section-3-slide-image-1-frame-2 img', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-about-section-3-slides-main-wrapper',
      start: coAboutSlide2Start,
      end: coAboutSlide2End,
      scrub: 0.6
    },
    scale: 1.05
  })
  // SLIDE 3
  gsap.set('.co-about-section-3-slide-3', { autoAlpha: 0 });
  gsap.to('.co-about-section-3-slide-3', {
    scrollTrigger: {
      // markers: true,
      toggleActions: "play reverse play reverse",
      trigger: '.co-about-section-3-slides-main-wrapper',
      start: coAboutSlide3Start,
      end: coAboutSlide3End,
    },
    duration: coAboutFadeDuration,
    ease: coAboutFadeEase,
    autoAlpha: 1
  })
  // slide 3 center image
  gsap.set('.co-about-section-3-slide-3 .co-about-section-3-slide-image-1-frame-2 img', { top: "-10%" });
  gsap.to('.co-about-section-3-slide-3 .co-about-section-3-slide-image-1-frame-2 img', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-about-section-3-slides-main-wrapper',
      start: coAboutSlide3Start,
      end: coAboutSlide3End,
      scrub: 0.6
    },
    top: "0%"
  })
  // SLIDE 4
  gsap.set('.co-about-section-3-slide-4', { autoAlpha: 0 });
  gsap.to('.co-about-section-3-slide-4', {
    scrollTrigger: {
      // markers: true,
      toggleActions: "play none none reverse",
      trigger: '.co-about-section-3-slides-main-wrapper',
      start: coAboutSlide4Start,
      end: coAboutSlide4End,
    },
    duration: coAboutFadeDuration,
    ease: coAboutFadeEase,
    autoAlpha: 1
  })
  // slide 4 bg image
  gsap.set('.co-about-section-3-slide-4 .co-about-section-3-slide-image-2', { top: "0%" });
  gsap.to('.co-about-section-3-slide-4 .co-about-section-3-slide-image-2', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-about-section-3-slides-main-wrapper',
      start: coAboutSlide4Start,
      end: coAboutSlide4End,
      scrub: 0.5
    },
    top: "-5%"
  })
  // slide 4 center image
  gsap.set('.co-about-section-3-slide-4 .co-about-section-3-slide-image-1-frame-2 img', { top: "-5%" });
  gsap.to('.co-about-section-3-slide-4 .co-about-section-3-slide-image-1-frame-2 img', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-about-section-3-slides-main-wrapper',
      start: coAboutSlide4Start,
      end: coAboutSlide4End,
      scrub: 0.6
    },
    top: "0%"
  })
  coMM.add("(min-width: 750px)", () => {
    // slide 1 frame
    gsap.set('.co-about-section-3-slide-1 .co-about-section-3-slide-frame-1', { top: "0%" });
    gsap.to('.co-about-section-3-slide-1 .co-about-section-3-slide-frame-1', {
      scrollTrigger: {
        // markers: true,
        trigger: '.co-about-section-3-slides-main-wrapper',
        start: coAboutSlide1ScrubStart,
        end: coAboutSlide1ScrubEnd,
        scrub: 0.75
      },
      top: "-2.5%"
    })
    // slide 2 frame
    gsap.set('.co-about-section-3-slide-2 .co-about-section-3-slide-frame-1', { top: "0%" });
    gsap.to('.co-about-section-3-slide-2 .co-about-section-3-slide-frame-1', {
      scrollTrigger: {
        // markers: true,
        trigger: '.co-about-section-3-slides-main-wrapper',
        start: coAboutSlide2Start,
        end: coAboutSlide2End,
        scrub: 0.75
      },
      top: "-2.5%"
    })
    // slide 3 frame
    gsap.set('.co-about-section-3-slide-3 .co-about-section-3-slide-frame-1', { top: "0%" });
    gsap.to('.co-about-section-3-slide-3 .co-about-section-3-slide-frame-1', {
      scrollTrigger: {
        // markers: true,
        trigger: '.co-about-section-3-slides-main-wrapper',
        start: coAboutSlide3Start,
        end: coAboutSlide3End,
        scrub: 0.75
      },
      top: "-2.5%"
    })
    // slide 4 frame
    gsap.set('.co-about-section-3-slide-4 .co-about-section-3-slide-frame-1', { top: "0%" });
    gsap.to('.co-about-section-3-slide-4 .co-about-section-3-slide-frame-1', {
      scrollTrigger: {
        // markers: true,
        trigger: '.co-about-section-3-slides-main-wrapper',
        start: coAboutSlide4Start,
        end: coAboutSlide4End,
        scrub: 0.75
      },
      top: "-2.5%"
    })
  });
}
// ========================================================================================================== SECTION 5
// ===================================================== GSAP
gsap.set('.co-about-section-5-right-image-bg img', { top: "0%", transition: 0 });
gsap.to('.co-about-section-5-right-image-bg img', {
  scrollTrigger: {
    trigger: '.co-about-section-5', start:'top bottom', end: "bottom top", scrub: 1
  },
  top: "-10%"
});
// TIMELINE
gsap.set('.co-about-section-5-ani-item', { opacity: 0, y: 60, transition: 0 });
let coAboutSection5ItemsTimeline = gsap.timeline({ paused: true });
coAboutSection5ItemsTimeline.to(".co-about-section-5-ani-item", {
  duration: 1,
  ease: "power2.inOut",
  y: 0,
  opacity: 1,
  stagger: 0.1
});
ScrollTrigger.create({
  trigger: '.co-about-section-5', start:'25% bottom', end: "bottom top",
  animation: coAboutSection5ItemsTimeline
});
// ========================================================================================================== SECTION 6
gsap.set('.co-about-section-6-right-image-bg img', { top: "0%", transition: 0 });
gsap.to('.co-about-section-6-right-image-bg img', {
  scrollTrigger: {
    trigger: '.co-about-section-6', start:'top bottom', end: "bottom top", scrub: 1
  },
  top: "-10%"
});
gsap.set('.co-about-section-6-left-image>div img', { top: "-10%", transition: 0 });
gsap.to('.co-about-section-6-left-image>div img', {
  scrollTrigger: {
    trigger: '.co-about-section-6', start:'top bottom', end: "bottom top", scrub: 1
  },
  top: "0%"
});
gsap.set('.co-about-section-6-left-image>div', { y: 0, scale: 1, transition: 0 });
gsap.to('.co-about-section-6-left-image>div', {
  scrollTrigger: {
    trigger: '.co-about-section-6', start:'top bottom', end: "bottom top", scrub: 1
  },
  y: -50,
  scale: 1.05
});